export default "__VITE_ASSET__qBDPxv6N__"